import React from 'react';
import { useStore } from 'effector-react';
import { ImageType, SceneType } from '@types';
import { $editingFlag, $editingLangFlag } from '@stores/editingStores';
import { $curScene, $tourData } from '@stores/dataStores';
import { $isCn } from '@stores/langStores';
import useTemplateFeature from '@hooks/useTemplateFeature';
import useEditingStore from '@hooks/useEditingStore';
import { $GateCategoryHeight } from '@stores/uiStores';
import Image from '@components/Image';
import useLangString from '@hooks/useLangString';

function WFeatureTogglesMA() {
  const isMatrix = useStore($curScene)?.type === SceneType.matrix;
  const isCn = useStore($isCn);
  const langFeature = useTemplateFeature('language');
  const flag = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.flag,
    $editing: $editingFlag.store,
  });
  const langFlag = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.config?.language?.showButton,
    $editing: $editingLangFlag.store,
  });
  const height = useStore($GateCategoryHeight.state);
  const lang = useLangString(
    {
      fs: ['全屏', 'Fullscreen'],
      hotspot: ['热点', 'Hotspots'],
      vr: ['VR模式', 'VR Mode'],
      vs: ['视角切换', 'View Settings'],
    },
    []
  );

  const showFS = !!(flag?.showFullscreenBtn ?? 1);

  const showVR = !!(flag?.showVRBtn ?? 1) && !isMatrix;
  const showVS = !!(flag?.showViewSwitchBtn ?? 1) && !isMatrix;
  const showLang = langFeature && !!(langFlag ?? 0);
  const showHotspotBtn = !!(flag?.showHotspotBtn ?? 0);

  if (!height) return null;

  const renderIcon = (src: string, text: string) => (
    <div className="mx-15 flex items-center">
      <Image src={src} type={ImageType.sysMedia} className="h-24 w-24" />
      <div className="ml-5">{text}</div>
    </div>
  );

  return (
    <div
      className="absolute right-0 left-0 flex h-45 items-center justify-center bg-black bg-opacity-80"
      style={{ bottom: height }}
    >
      {showFS &&
        renderIcon('/imgs/fm-fs.ab8eec2d6846f688049854f5a244144c.png', lang.fs)}
      {showHotspotBtn &&
        renderIcon(
          '/imgs/hotspot.f8f27fec7b9c8ed9c990d6e9609eaa42.png',
          lang.hotspot
        )}
      {showVR &&
        renderIcon('/imgs/fm-vr.a1c53a257aa1497bb87098c45c44d917.png', lang.vr)}
      {showVS &&
        renderIcon('/imgs/fm-vs.7a324be8d63b99b95089400574a21554.png', lang.vs)}
      {showLang &&
        isCn &&
        renderIcon(
          '/imgs/fm-en.a255552c6c92143d98b2a18c5a6cc09f.png',
          'English'
        )}
      {showLang &&
        !isCn &&
        renderIcon(
          '/imgs/fm-cn.50b2c1243626b36f5ae065498b6a8e42.png',
          '简体中文'
        )}
    </div>
  );
}

export default WFeatureTogglesMA;
